import { CreativityType } from '../../types/banner';
import type { TemplateConfig } from '../../types/templates';
import { useTemplateConfig } from './use-template-config';

export interface MediaVariant {
  video?: string;
  image?: string;
}

interface TemplateInfo {
  title: string;
  previewVideo: string | undefined;
  mediaVariants: Record<string, MediaVariant>;
  thumbnail: string | undefined;
}

const toMediaVariants = (template: TemplateConfig): Record<string, MediaVariant> => {
  const result: Record<string, MediaVariant> = {};
  if (template.mode !== 'legacy' || !template.previewByResolution) return result;
  for (const [resId, preview] of Object.entries(template.previewByResolution)) {
    result[resId] = preview.kind === 'image' ? { image: preview.url } : { video: preview.url };
  }
  return result;
};

export const useTemplateInfo = (creativityType?: CreativityType): TemplateInfo => {
  const template = useTemplateConfig(creativityType);

  if (!creativityType || !template) {
    return { title: '', previewVideo: undefined, mediaVariants: {}, thumbnail: undefined };
  }

  return {
    title: template.title || creativityType,
    previewVideo: template.thumbnail.hoverVideo,
    mediaVariants: toMediaVariants(template),
    thumbnail: template.thumbnail.url
  };
};
